import { captureException } from '@sentry/react';
import config from 'config';

export function notifySentryNorthstar(error, gqlQuery, variables) {
  captureException(error, (scope) => {
    const { environment } = config.get('public.sentry');
    scope.addEventProcessor(function (event) {
      event.environment = environment;
      return event;
    });
    scope.setContext('Query', {
      gqlQuery: gqlQuery,
      variables: JSON.stringify(variables),
    });
    scope.setTransactionName('Northstar - Fatal Error');
  });
}
